import * as eventRoutines from '../Events/eventRoutines';
import { connect } from 'react-redux';
import React from 'react';
import SimpleToggleBlock from '../../Components/Atoms/SimpleToggleBlock/SimpleToggleBlock';

/* Used to pass in store data as default values into SimpleToggleBlock which uses the SimpleForm */
interface IModule {
    activeModules: {
        [key: string]: any;
    };
    updateActiveModule: Function;
    name: string;
    label: string;
    children: any;
}

const Module = (props: IModule) => {
    const { name, activeModules, updateActiveModule } = props;

    const checked = activeModules ? activeModules[name] : false;

    const handleModuleToggle = (value: { [key: string]: boolean }) => {
        let field = Object.keys(value)[0];

        updateActiveModule({ moduleName: field, status: value[field] });
    };
    return <SimpleToggleBlock onSubmit={handleModuleToggle} checked={checked} {...props} />;
};

function mapStateToProps(state: any) {
    return {
        activeModules: state.activeModules.primary,
    };
}

const mapDispatchToProps = {
    updateActiveModule: eventRoutines.updateActiveModule,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Module);
